import { useIsMacDesktop } from "./hooks/useIsMacDesktop";

/**
 * Warns Mac users that dragging out of Apple Photos hands over a small
 * derivative — a still frame for a video, a downscaled JPEG for a photo —
 * instead of the original. The dropped file looks ordinary, so this can only
 * be warned about before the drag, never detected after it.
 */
export function ApplePhotosTip({
  media,
  className,
}: {
  /** Plural noun phrase completing "dragging your ___", e.g. "photos and
   * videos". Varies by what the host accepts. */
  media: string;
  className?: string;
}) {
  const isMacDesktop = useIsMacDesktop();

  // Empty `media` would render "dragging your  to a desktop folder".
  if (!isMacDesktop || !media.trim()) {
    return null;
  }

  return (
    <p className={className}>
      <span className="font-semibold">Using Apple Photos?</span> Try dragging
      your {media} to a desktop folder first, then drag them here. That will
      ensure you upload the whole file and not just a thumbnail.
    </p>
  );
}
